<template>
  <nx-fullscreen-dialog :title="blockTitle" :active="active" @dismiss="dismiss">

    <template slot="toolbar-items">
      <v-btn
          color="accent"
          flat
          :disabled="!isValid"
          @click="insertBlot"
          v-html="buttonTitle"
      ></v-btn>
    </template>

    <v-container fluid pb-3>
      <v-layout>
        <v-flex offset-md2 md8 pt-4>
          <h2 class="nx-block-headline">{{ formTitle }}</h2>

          <v-textarea
              autofocus
              v-model="data.html"
              :label="codeTitle"
              :placeholder="placeholderTitle"
              :error-messages="error"
              auto-grow
          ></v-textarea>

          <v-select
              :items="responsiveOptions"
              v-model="data.responsive"
              item-text="text"
              item-value="value"
              label="Relación de aspecto"
          ></v-select>

        </v-flex>
      </v-layout>
    </v-container>
  </nx-fullscreen-dialog>
</template>

<script>
import _isEmpty from 'lodash/isEmpty';
import DialogButton from './DialogButton';

/**
 * CodeButton Component
 *
 * Extend DialogButton component
 *
 */

export default {
  name: 'nx-code-button',
  extends: DialogButton,
  props: {
    embedHtml: String,
    embedResponsive: String,
  },
  data() {
    return {
      name: 'codeEmbed',
      data: {
        html: this.embedHtml || '',
        responsive: this.embedResponsive || 'none',
      },
      responsiveOptions: [
        {
          value: 'none',
          text: 'No controlar la relación de aspecto',
        }, {
          value: '16:9',
          text: 'Respetar una relación de aspecto de 16:9',
        }, {
          value: '9:16',
          text: 'Respetar una relación de aspecto de 9:16',
        }, {
          value: '4:3',
          text: 'Respetar una relación de aspecto de 3:4',
        }, {
          value: '1:1',
          text: 'Respetar una relación de aspecto de 1:1',
        },
      ],
    };
  },
  computed: {
    blockTitle() {
      return this.$t('message.block.code');
    },
    codeTitle() {
      return this.$t('message.block.form.code');
    },
    placeholderTitle() {
      return this.$t('message.block.form.codePlaceholder');
    },
    isValid() {
      return !_isEmpty(this.data.html);
    },
  },
};
</script>
